import type { Row } from "@tanstack/react-table"
import type { ReactElement } from "react"
import { useQuery } from "urql"

import { getPurchaseOrderProductTableColumns } from "../../PurchaseOrder/ProductAdded/components/getPurchaseOrderProductTableColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { Order, OrderLine } from "@/graphql/codegen/graphql"
import { PurchaseOrderExpandedLinesDocument } from "@/graphql/codegen/graphql"

const EXPANDED_LINES_LIMIT = 20

const isOrderRow = (row: OrderLine | Order): row is Order => "orderId" in row

export const PurchaseOrdersExpandedRowDetails = (row: Row<OrderLine | Order>): ReactElement => {
  const original = row.original
  const isOrder = isOrderRow(original)

  const [{ data, fetching }] = useQuery({
    query: PurchaseOrderExpandedLinesDocument,
    variables: {
      input: {
        filter: { orderId: isOrder ? original.orderId : 0, isDeleted: false },
        limit: EXPANDED_LINES_LIMIT,
      },
    },
    pause: !isOrder,
  })

  const showCompanyName = Boolean(row?.original?.product?.company?.name)
  const columns = getPurchaseOrderProductTableColumns({
    isReadOnly: true,
    showCompanyName,
    order: row.original as Order,
  })

  const fetchedLines =
    data?.order.getOrderLineList.__typename === "OrderLineListSuccess" ? data.order.getOrderLineList.orderLines : []

  const products = (isOrder ? fetchedLines : [original]) as (OrderLine | Order)[]

  return (
    <div className='p-6'>
      <AerosBaseTable<OrderLine | Order>
        features={{
          tanstackOptions: {
            columns,
            data: products,
          },
        }}
        slotProps={{
          headerCell: { className: "bg-primary-100" },
        }}
        noDataMessage={isOrder && fetching ? "Loading..." : "No products found"}
      />
    </div>
  )
}
